import { useCallback, useMemo, useState, type ReactNode } from 'react';
import OrcKnowledgeModal from './OrcKnowledgeModal';
import {
  OrcKnowledgeModalContextProvider,
  type OrcKnowledgeLinkTarget,
} from './OrcKnowledgeModalContext';

interface OrcKnowledgeModalProviderProps {
  children: ReactNode;
}

export default function OrcKnowledgeModalProvider({ children }: OrcKnowledgeModalProviderProps) {
  const [target, setTarget] = useState<OrcKnowledgeLinkTarget | null>(null);
  const openOrcKnowledgeTarget = useCallback((nextTarget: OrcKnowledgeLinkTarget) => {
    if (!nextTarget.type || !nextTarget.id) return;
    setTarget(nextTarget);
  }, []);
  const value = useMemo(() => ({ openOrcKnowledgeTarget }), [openOrcKnowledgeTarget]);

  return (
    <OrcKnowledgeModalContextProvider value={value}>
      {children}
      <OrcKnowledgeModal target={target} onClose={() => setTarget(null)} />
    </OrcKnowledgeModalContextProvider>
  );
}
